import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useId, useMemo } from 'react';
import { CardContext } from './Card.context.esm.js';
import styles from './Card.styles.esm.js';
import { CardContent } from './components/Content/CardContent.esm.js';
import { CardImage } from './components/Image/CardImage.esm.js';
import { cn } from '../../utils/cn.esm.js';
import { simulateButtonKeyboardBehavior } from '../../utils/buttonKeyboardBehavior.esm.js';

const CardComponent = forwardRef((_a, ref) => {
    var { id: _id, className, inverse = false, variant = "standard", "aria-label": ariaLabel, onClick, children, interactive, href, imagePosition = "top" } = _a, props = __rest(_a, ["id", "className", "inverse", "variant", "aria-label", "onClick", "children", "interactive", "href", "imagePosition"]);
    const id = useId();
    const classes = styles({
        inverse,
        variant,
        imagePosition,
        interactive,
    });
    const classNames = cn(classes.container(), className);
    const Tag = useMemo(() => {
        if (!interactive)
            return "div";
        return href ? "a" : "button";
    }, [href, interactive]);
    const tabIndex = useMemo(() => {
        if (!interactive) {
            return undefined;
        }
        return 0;
    }, [interactive]);
    return (jsx(CardContext.Provider, { value: { imagePosition }, children: jsx(Tag, Object.assign({ ref: ref, id: _id !== null && _id !== void 0 ? _id : id, className: classNames, tabIndex: tabIndex, "aria-label": interactive ? ariaLabel : undefined, onKeyDown: Tag === "button"
                ? simulateButtonKeyboardBehavior(onClick)
                : undefined }, (Tag === "button" && { onClick }), (Tag === "a" && { href }), props, { children: children })) }));
});
CardComponent.displayName = "Card";
CardImage.displayName = "CardImage";
CardContent.displayName = "CardContent";
const Card = CardComponent;
Card.Image = CardImage;
Card.Content = CardContent;

export { Card };
